<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
                <router-link to="/packages">{{$t('packaging')}}</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">{{title}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="saveClick"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('farm') }}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="header.BranchId">
                                        <option value=""></option>
                                        <option v-for="ret in branches" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('remark') }}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="header.Description" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('date') }}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="header.Date"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="grid">
                                <thead>
                                    <tr>
                                        <th class="blue">{{$t('item_name')}}</th>
                                        <th class="blue">{{$t('description')}}</th>
                                        <th class="blue" style="width: 120px;">{{$t('qty_base')}}</th>
                                        <th class="blue" style="width: 120px;">{{$t('qty_lost')}}</th>
                                        <th class="blue" style="width: 120px;">{{$t('uom_base')}}</th>
                                        <th class="blue" style="width: 120px;">{{$t('qty_packaging')}}</th>
                                        <th class="blue" style="width: 120px;">{{$t('uom_packaging')}}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret, index) in lines" :key="index">
                                        <td><AuthCompleted :value="ret.ItemName" @select="onSelect($event, ret)"></AuthCompleted></td>
                                        <td><input type="text" class="form-control form-control-sm" v-model="ret.Description" :disabled="ret.ItemId==''" /></td>
                                        <td><input type="number" class="form-control form-control-sm" v-model="ret.Quantity" :disabled="ret.ItemId==''" /></td>
                                        <td><input type="number" class="form-control form-control-sm" v-model="ret.LostQuantity" min="0" :disabled="ret.ItemId==''"/></td>
                                        <td><UomDropdown :value="ret.UomName" :item_id="ret.ItemId" @select="uomChange($event, ret, 1)"></UomDropdown></td>
                                        <td><input type="number" class="form-control form-control-sm" v-model="ret.ToQuantity" :disabled="ret.ItemId==''"/></td>
                                        <td><UomDropdown :value="ret.ToUomName" :item_id="ret.ItemId" @select="uomChange($event, ret, 2)"></UomDropdown></td>
                                        <td style="width: 30px;">
                                            <button type="button"
                                                    class="btn btn-danger btn-remove"
                                                    @click="removeLine(index)">
                                                X
                                            </button>
                                        </td>
                                    </tr>
                                <tr>
                                    <td>
                                        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="addLine"><i class="fa fa-plus"></i> {{ $t('add_line') }}</button>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { AuthCompleted } from '../Item';
import UomDropdown from '../UOM/Dropdown';
//import { required } from 'vuelidate/lib/validators'
export default {
    components: {
        AuthCompleted,
        UomDropdown
    },
    data(){
        return {
            title: this.$t('packaging_create'),
            header: {
                Date: this.$now().format('YYYY-MM-DD')
            },
            lines: [{
                ItemId: '',
                ItemName: '',
                Description: '',
                UomName: '',
                UomId: '',
                ToUomName: '',
                ToUomId: '',
                Quantity: 0,
                LostQuantity: 0,
                ToQuantity: 0
            }],
            branches: []
        }
    },
    created(){
        this.branchList();
        let id = this.$route.params.id;
        if(id !== undefined && id !== null && id !== ''){
            this.findById(id);
        }
    },
    validations:{
        header: {

        }
    },
    methods: {
        addLine(){
            this.lines.push({
                ItemId: '',
                ItemName: '',
                Description: '',
                UomName: '',
                UomId: '',
                ToUomName: '',
                ToUomId: '',
                Quantity: 0,
                LostQuantity: 0,
                ToQuantity: 0
            });
        },
        onSelect(item, line){
            line.Description = item.Name;
            line.ItemId = item.Id;
            line.ToUomId = item.UomId;
            line.ToUomName = item.UomName;
        },
        saveClick(){
            this.$v.$touch();
            if(!this.$v.$invalid) {
                let loading = this.$loading.show();
                let req = {
                    Header: this.header,
                    Lines: this.lines
                };
                this.$api().post('package/save', req).then(res => {
                    if(this.$isValid(res)){
                        this.$router.push('/packages');
                    }
                }).finally(function() { loading.hide(); });
            }
        },
        findById(id){
            let loading = this.$loading.show();
            this.$api().post('package/find', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    let data = res.data.Json;
                    this.header = data.Header;
                    this.title = '['+this.header.Num+']';
                    this.header.Date = this.$format(this.header.Date, 'YYYY-MM-DD');
                    this.lines = data.Lines;
                }
            }).finally(function() { loading.hide(); });
        },
        uomChange(e, line, n){
            if(n == 1){
                line.UomId = e.UomId;
                line.UomName = e.UomName;
            }else if(n == 2){
                line.ToUomId = e.UomId;
                line.ToUomName = e.UomName;
            }
        },
        branchList: async function(){
            var res = await this.$api().post('branch/list', { Limit: 0 });
            if(this.$isValid(res)){
                this.branches = res.data.Data;
            }
        },
        removeLine(index){
            this.lines.splice(index, 1);
        },
    }
}
</script>